import { mapGetters } from 'vuex';
export default {
    name:'search-not-found',
    computed:{
        ...mapGetters({
            search:'search/search',
        })
    },
}
